import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './RoleSelection.css';

const RoleSelection = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [selectedRole, setSelectedRole] = useState('seller'); // Default to seller

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const products = [
    { id: 'cotton', name: 'Cotton', icon: '🌱' },
    { id: 'viscose', name: 'Viscose', icon: '🌿' },
    { id: 'polyester', name: 'Polyester', icon: '🧪' },
    { id: 'cotton-waste', name: 'Cotton Waste', icon: '♻️' },
    { id: 'yarn', name: 'Yarn', icon: '🧵' },
    { id: 'fabric', name: 'Fabric', icon: '👕' },
    { id: 'spare-parts', name: 'Spare parts (New/Used)', icon: '⚙️' },
    { id: 'units', name: 'Sell / Conversion / Lease', icon: '🏭', sub: '(Mill/Gin/Units)' }
  ];

  const profileInfo = {
    company: 'GoEasy Mills Pvt Ltd',
    address: 'Sector 44, Business Hub, Mumbai, Maharashtra 400001',
    contact: '+91 98765 43210 | trade@goeasymills.com'
  };

  const handleProductClick = (productId) => {
    if (selectedRole === 'seller') {
      navigate(`/seller/domestic-hvi?product=${productId}`);
    } else {
      navigate(`/buyer/domestic-hvi?product=${productId}`);
    }
  };

  return (
    <div className="role-selection-wrapper">
      <div className="selection-container">
        {/* Header */}
        <header className="selection-header">
          <h1 className="main-logo">
            <span className="accent">Go</span>Easy<span className="accent">Trade</span>
          </h1>
          <p className="welcome-tag">Welcome, Please select your trade profile</p>
        </header>

        {/* Role Toggle */}
        <div className="role-integration-layer">
          <div className="profile-micro-card">
            <div className="profile-row">
              <span className="profile-label">🏢 Company Profile:</span>
              <span className="profile-value">{profileInfo.company}</span>
            </div>
            <div className="profile-row">
              <span className="profile-label">📍 Address:</span>
              <span className="profile-value">{profileInfo.address}</span>
            </div>
            <div className="profile-row">
              <span className="profile-label">📞 Contact:</span>
              <span className="profile-value">{profileInfo.contact}</span>
            </div>
          </div>

          <div className="role-toggle-bar">
            <div className={`role-tab ${selectedRole === 'seller' ? 'active' : 'diminished'}`} onClick={() => setSelectedRole('seller')}>
              <span className="role-icon">🏭</span>
              <span className="role-label-group">
                <span className="role-main">Seller</span>
                <span className="role-hint">I want to Sell</span>
              </span>
            </div>
            <div className={`role-tab ${selectedRole === 'buyer' ? 'active' : 'diminished'}`} onClick={() => setSelectedRole('buyer')}>
              <span className="role-icon">🛒</span>
              <span className="role-label-group">
                <span className="role-main">Buyer</span>
                <span className="role-hint">I want to Buy</span>
              </span>
            </div>
          </div>
        </div>

        {/* Product Grid */}
        <div className="product-selection-section">
          <h2 className="section-title">Select Product Type</h2>
          <div className="product-grid">
            {products.map((product) => (
              <div
                key={product.id}
                className="product-box-compact"
                onClick={() => handleProductClick(product.id)}
              >
                <div className="p-icon-small">{product.icon}</div>
                <div className="p-name-stack">
                  <span className="p-main-name">{product.name}</span>
                  {product.sub && <span className="p-sub-name">{product.sub}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <footer className="selection-footer">
          <p>© 2026 GoEasyTrade - Sustainable Trading Ecosystem</p>
        </footer>
      </div>
    </div>
  );
};

export default RoleSelection;
